module.exports = __webpack_public_path__ + "blackclothing.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackclothing.png
// module id = 850
// module chunks = 0